//スクロール アニメーション
$(function () {
  $('a[href^="#"]').on("click", function () {
    var href = $(this).attr("href")
    var target = $(href == "#" || href == "" ? "html" : href)
    var position = target.offset().top
    $("html, body").animate({ scrollTop: position }, 550, "swing")
    return false
  })
})

//jQeury メニューボタン
$(function () {
  var $nav = $("#navArea")
  var $btn = $("#toggle_btn")
  var $mask = $("#mask")
  var $nav_li = $(".nav_li")
  var open = "open" // class

  $btn.on("click", function () {
    if (!$nav.hasClass(open)) {
      $nav.addClass(open)
    } else {
      $nav.removeClass(open)
    }
  })
  // mask close
  $mask.on("click", function () {
    $nav.removeClass(open)
  })
  $nav_li.on("click", function () {
    $nav.removeClass(open)
  })
})

$(window).on("load", function () {
  //映像再生
  // document.querySelectorAll("video").forEach((video) => {
  //   video.addEventListener("mouseover", () => {
  //     video.play()
  //   })

  //   video.addEventListener("mouseout", () => {
  //     // pauseが非同期のplayを邪魔しないよう、thenの中に入れる
  //     video.play().then(function () {
  //       video.pause()
  //     })
  //   })
  //  var video = $('video').get(0);
  //   video.muted = true;
  // })

  // videoタグとbuttonタグを変数に格納
  const video = document.querySelector(".js-video")
  const videoButton = document.querySelector(".js-video-button")

  if (video) {
    video.volume = 0.25
    
    // PCブラウザでの自動再生を確実にするため、play()を明示的に呼び出す
    // muted状態でのみ自動再生が許可される
    video.muted = true
    
    // 動画の再生を試みる
    const playPromise = video.play()
    
    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          // 自動再生に成功
          console.log("Video autoplay started")
        })
        .catch((error) => {
          // 自動再生に失敗した場合
          console.log("Video autoplay failed:", error)
          // ユーザーインタラクション後に再生を試みる
          document.addEventListener("click", function startVideo() {
            video.play()
            document.removeEventListener("click", startVideo)
          }, { once: true })
        })
    }
  }
  
  // mutedを操作する関数を定義
  const toggleAudio = () => {
    if (video) {
      video.muted = !video.muted
    }
  }

  // ボタンの入れ替えを操作する関数を定義
  const toggleButton = () => {
    if (videoButton) {
      videoButton.classList.toggle("on")
    }
  }

  if (videoButton && video) {
    videoButton.addEventListener("click", () => {
      // 関数を実行
      toggleAudio()
      toggleButton()
    })
  }
})

$(function () {
  //マーキー
  const marqueeTexts = document.querySelectorAll(".marquee-inner")

  marqueeTexts.forEach((marqueeText) => {
    marqueeText.animate(
      {
        translate: [0, "calc(-100% - 1rem)"],
      },
      {
        duration: 40000,
        iterations: Infinity,
      }
    )
  })

  //marqueeProduct
  const marqueeProductTexts = document.querySelectorAll(".marqueeProduct-inner")

  marqueeProductTexts.forEach((marqueeProductText) => {
    marqueeProductText.animate(
      {
        translate: [0, "calc(-100% - 1rem)"],
      },
      {
        duration: 40000,
        iterations: Infinity,
      }
    )
  })

  // ヘッダーロゴの表示制御
  // TOPページ（ヒーロースライダーあり）のみスクロールで表示、それ以外は即表示
  if (document.querySelector('.header #splide01')) {
    $(window).on('scroll', function() {
      const aboutBlock = document.getElementById('aboutBlock');
      if (aboutBlock) {
        const aboutBlockTop = aboutBlock.offsetTop;
        if ($(this).scrollTop() >= aboutBlockTop) {
          $('#gNav_logo').addClass('show');
        } else {
          $('#gNav_logo').removeClass('show');
        }
      } else {
        // aboutBlockが存在しない場合は100pxで表示
        if ($(this).scrollTop() > 100) {
          $('#gNav_logo').addClass('show');
        } else {
          $('#gNav_logo').removeClass('show');
        }
      }
    });
  } else {
    // TOPページ以外は開いた瞬間から常に表示
    $('#gNav_logo').addClass('show');
  }

  // マウスストーカー
  const stalker = document.getElementById('js-stalker');
  const stalkerWrap = document.getElementById('js-stalker-wrap');
  if (stalker && stalkerWrap) {
    let mouseX = 0;
    let mouseY = 0;
    let currentX = 0;
    let currentY = 0;
    const speed = 0.15;

    // マウスストーカーを表示
    setTimeout(function() {
      stalkerWrap.style.opacity = '1';
    }, 2000);

    document.addEventListener('mousemove', function(e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
    });

    function updateStalker() {
      const distX = mouseX - currentX;
      const distY = mouseY - currentY;

      currentX += distX * speed;
      currentY += distY * speed;

      stalker.style.left = currentX + 'px';
      stalker.style.top = currentY + 'px';

      requestAnimationFrame(updateStalker);
    }

    updateStalker();

    // リンクやボタンにホバーしたときに拡大
    const hoverTargets = document.querySelectorAll('a, button, input[type="submit"], input[type="button"], label, #menu_btn');
    hoverTargets.forEach(function(target) {
      target.addEventListener('mouseenter', function() {
        stalker.classList.add('is_active');
      });
      target.addEventListener('mouseleave', function() {
        stalker.classList.remove('is_active');
      });
    });
  }
})
// 住所削除
window.addEventListener("load", () => {
  Shopify.postLink = function (path, options) {
    options = options || {}
    var method = options["method"] || "post"
    var params = options["parameters"] || {}

    var form = document.createElement("form")
    form.setAttribute("method", method)
    form.setAttribute("action", path)

    for (var key in params) {
      var hiddenField = document.createElement("input")
      hiddenField.setAttribute("type", "hidden")
      hiddenField.setAttribute("name", key)
      hiddenField.setAttribute("value", params[key])
      form.appendChild(hiddenField)
    }
    document.body.appendChild(form)
    form.submit()
    document.body.removeChild(form)
  }

  $(function () {
    const handleDeleteButtonClick = ({ currentTarget }) => {
      // eslint-disable-next-line no-alert

      if (confirm("本当に削除しますか？")) {
        Shopify.postLink(currentTarget.dataset.target, {
          parameters: { _method: "delete" },
        })
      }
    }

    const deleteAddressButton = document.querySelectorAll(".delete-button")
    deleteAddressButton.forEach((element) => {
      element.addEventListener("click", handleDeleteButtonClick)
    })
  })
})

$(function () {
  /* 20241008追記 */

  $(".js-time_limited").each(function () {
    var appearTime = $(this).data("appear_time")
    var disappearTime = $(this).data("disappear_time")
    var threshould_start = Date.parse(appearTime)
    var threshould_end = Date.parse(disappearTime)
    // 現在の日時をもつDateオブジェクトを作成
    var current = new Date()
    if (threshould_start < current && threshould_end > current) {
      $(this).addClass("js-time_limited_fire")
      const loadingBtn = document.querySelectorAll(".loadingBtn")
      const loadingBg = document.getElementById("loading")

      loadingBtn.forEach((btn) => {
        btn.addEventListener("click", () => {
          $(loadingBg).css("display", "none")
        })
      })
      const webStorage = function () {
        if (sessionStorage.getItem("visit")) {
          $(loadingBg).css("display", "none")
        } else {
          sessionStorage.setItem("visit", "true")
          $(loadingBg).css("display", "block")
        }
      }
      webStorage()
    } else {
      // 同じ時間、もしくはそれ以前ならば
      $(this).removeClass("js-time_limited_fire")
    }
  })
})
$(function () {
  const $wrap = $(".number-spinner-wrap")
  const $purchaseNumInput = $(".number-spinner-wrap input")
  const $btnMinus = $(".number-spinner-wrap .spinner-down")
  const $btnPlus = $(".number-spinner-wrap .spinner-up")
  $($btnPlus).on("click", function () {
    let $currentInput = $(this).prev().prev($("input"))
    var quantity = parseInt($($currentInput).val())
    $currentInput.val(parseInt(quantity) + 1)
  })
  $($btnMinus).on("click", function () {
    let $currentInput = $(this).prev($("input"))
    var quantity = parseInt($($currentInput).val())
    if (quantity > 0) {
      $($currentInput).val(parseInt(quantity) - 1)
    }
  })
  $(".show-add-address-form").click(function () {
    $(".add-address-form").toggle()
  })

  $(".show-edit-address-form").click(function () {
    const addressId = $(this).data("address-id")
    $(`#EditAddress_${addressId}`).toggle()
  })
  const selectedCountryOption = $(".country-select").data("default")
  var selectedCountryOptionValue = $(".country-select option")
    .filter(function (index) {
      return $(this).text() === selectedCountryOption
    })
    .val()
  $(`.country-select option[value="${selectedCountryOptionValue}"]`).prop("selected", true)

  const selectedProvinceOption = $(".province-select").data("default")
  var selectedProvinceOptionValue = $(".province-select option")
    .filter(function (index) {
      return $(this).text() === selectedProvinceOption
    })
    .val()
  $(`.province-select option[value="${selectedProvinceOptionValue}"]`).prop("selected", true)
})
